import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

const UnauthorizedPage = () => {
  const { currentUser } = useAuth()

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center p-6 text-center">
      <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-red-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">Access Denied</h1>
      <p className="text-gray-600 mb-6">You don't have permission to access this page.</p>
      <div className="flex gap-4">
        <Link
          to="/"
          className="px-4 py-2 bg-neutral-200-100 hover:bg-neutral-200 rounded text-gray-800 transition-colors"
        >
          Go Home
        </Link>
        {currentUser && (
          <Link
            to="/account"
            className="px-4 py-2 bg-primary hover:bg-primary-dark rounded text-white transition-colors"
          >
            My Account
          </Link>
        )}
      </div>
    </div>
  )
}

export default UnauthorizedPage
